import React from 'react';
import { Link } from 'react-router-dom';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  headerAction?: React.ReactNode;
  /** Feather icon name shown before the title, e.g. "bar-chart-2". */
  icon?: string;
}

export function Card({ children, className = '', title, subtitle, headerAction, icon }: CardProps) {
  return (
    <div className={`card ${className}`}>
      {(title || headerAction) && (
        <div className="card-header d-flex align-items-center justify-content-between">
          <div>
            {title && <h5 className="card-title section-heading mb-0">
              {icon && <i className={`feather-${icon}`} aria-hidden="true"></i>}
              {title}
            </h5>}
            {subtitle && <p className="card-subtitle text-muted mb-0">{subtitle}</p>}
          </div>
          {headerAction}
        </div>
      )}
      <div className="card-body">{children}</div>
    </div>
  );
}

interface StatCardProps {
  title: string;
  value: number | string;
  icon: string;
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info' | 'dark';
  trend?: {
    value: number;
    direction: 'up' | 'down';
  };
  link?: string;
}

export function StatCard({ title, value, icon, color = 'primary', trend, link }: StatCardProps) {
  const cardContent = (
    <div className="card-body">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <p className="text-muted mb-1">{title}</p>
          <h3 className="mb-0 fw-bold">{value}</h3>
          {trend && (
            <small className={`text-${trend.direction === 'up' ? 'success' : 'danger'}`}>
              <i className={`feather-trending-${trend.direction} me-1`}></i>
              {trend.value}%
            </small>
          )}
        </div>
        <div className={`avatar-text avatar-lg bg-${color} bg-opacity-10 text-${color} rounded`}>
          <i className={`feather-${icon} fs-4`}></i>
        </div>
      </div>
    </div>
  );

  if (link) {
    return (
      <Link to={link} className="card text-decoration-none" style={{ cursor: 'pointer' }}>
        {cardContent}
      </Link>
    );
  }

  return (
    <div className="card">
      {cardContent}
    </div>
  );
}
